export default {
  validate: (value) => {
    return {
      valid: !!value,
      required: true,
    };
  },
  params: ['isAdditional'],
  message: (fieldName, { isAdditional = false }) => {
    return `Please type to search & then select ${isAdditional ? 'their' : 'your'} business.`;
  },
  computesRequired: true,
};
